<ng-container *ngIf="!string_filter && baseDatasourceDistributorExclusive.isTableLoaded && baseDatasourceDistributorExclusive.totalItem$.getValue() === 0; else elseBlock" cardBody>
  <app-card-empty icon="{{ iconNone }}" text="Belum terdapat distributor eksklusif."> </app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <!-- begin::Card -->
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <!--begin::Card header-->
    <ng-container cardHeader>
      <app-input-search
        (actionFilter)="onSearch($event)"
        [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject"
        [placeholder]="'Cari Nama Distributor'"
        [value]="string_filter"
      ></app-input-search>
      <div>
        <button (click)="handleHistory()" class="btn btn-outline btn-outline-disabled">
          <span [inlineSVG]="iconClock" class="img-fluid"></span>
        </button>
      </div>
    </ng-container>
    <!--end::Card header-->
    <!--begin::Card body-->
    <ng-container cardBody>
      <ng-container
        *ngIf="string_filter && baseDatasourceDistributorExclusive.isTableLoaded && baseDatasourceDistributorExclusive.totalItem$.getValue() === 0; else elseFilterBlock"
        cardBody
      >
        <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data product variant."></app-card-empty>
      </ng-container>
      <ng-template #elseFilterBlock>
        <div class="table-responsive">
          <table [dataSource]="baseDatasourceDistributorExclusive" class="table w-100 gy-5 table-row-bordered align-middle" mat-table matSort>
            <ng-container *ngFor="let tableColumn of tableColumns; index as i" [matColumnDef]="tableColumn.key">
              <ng-container *ngIf="tableColumn.isSortable; else notSortTable">
                <th
                  *matHeaderCellDef
                  [arrowPosition]="'after'"
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [mat-sort-header]="tableColumn.key"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="baseDatasourceDistributorExclusive.isFinishLoadingSubject.value">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasourceDistributorExclusive.isFinishLoadingSubject.value">
                    <app-table-content [width]="70"></app-table-content>
                  </div>
                </th>
              </ng-container>
              <ng-template #notSortTable>
                <th
                  *matHeaderCellDef
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [ngClass]="{
                    'min-w-70px text-center': tableColumn.key === 'actions',
                    'w-250px': tableColumn.key === 'alamat'
                  }"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="tableColumn.key === 'available_stock'" class="d-flex info-header-detail-products">
                    <div *ngIf="baseDatasourceDistributorExclusive.isFinishLoadingSubject.value">
                      {{ tableColumn.title }}
                    </div>
                    <div *ngIf="!baseDatasourceDistributorExclusive.isFinishLoadingSubject.value">
                      <app-table-content [width]="180"></app-table-content>
                    </div>
                    <span
                      *ngIf="baseDatasourceDistributorExclusive.isFinishLoadingSubject.value"
                      [inlineSVG]="iconInfo"
                      class="ms-2 cursor-pointer"
                      ngbPopover="Jumlah stok yang tersedia untuk diorder"
                      placement="bottom"
                      popoverClass="tooltip-info-product text-primary"
                    ></span>
                  </div>
                  <div *ngIf="baseDatasourceDistributorExclusive.isFinishLoadingSubject.value && tableColumn.key !== 'available_stock'">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasourceDistributorExclusive.isFinishLoadingSubject.value && tableColumn.key !== 'available_stock'">
                    <app-table-content [width]="180"></app-table-content>
                  </div>
                </th>
              </ng-template>
              <td *matCellDef="let element" class="px-3" mat-cell>
                <ng-container [ngSwitch]="tableColumn.key">
                  <div *ngSwitchCase="'actions'" class="text-center">
                    <button
                      [ngClass]="{
                        'is-download': element['is_download']
                      }"
                      class="btn btn-table-actions-download"
                    >
                      <app-table-content [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject" [type]="'icon'">
                        <span (click)="handleAction(element)" [inlineSVG]="iconAction"></span>
                      </app-table-content>
                    </button>
                  </div>
                  <div *ngSwitchCase="'list_variants'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject">
                      <div style="gap: 10px">
                        <span class="product-list">{{ setVariantItem(element[tableColumn.key])?.name}}</span><br>
                        <span *ngIf="element[tableColumn.key]?.length > 1"
                              class="desc">+{{ element[tableColumn.key]?.length-1 }} Varian lainnya</span>
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'submitted_time'">
                    <app-table-content [count]="2" [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject" [type]="'text'">
                      <div>{{ utilities.timeStampToDate(element['submitted_time'], 'dd-MM-yyyy') }}</div>
                      <div>{{ utilities.timeStampToDate(element['submitted_time'], 'HH:mm:ss') }}</div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'list_sub_areas'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject">
                      <div
                        class="line-clamp"
                      >
                        <span *ngIf="element[tableColumn.key]?.length; else defaultItemText"
                              placement="bottom"
                              popoverClass="tooltip-info-product text-primary"
                              triggers="mouseenter:mouseleave"
                              [ngbPopover]="mapSubAreaObject(element[tableColumn.key])"
                        ><ng-template [ngTemplateOutlet]="defaultItemText"></ng-template></span>
                        <ng-template #defaultItemText>
                          <span class="text-capitalize">{{ mapSubAreaObject(element[tableColumn.key]) }}</span>
                        </ng-template>
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchDefault>
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject">
                      <span>{{ element[tableColumn.key] ?? '-' }} </span>
                    </app-table-content>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          </table>
        </div>
        <div class="d-flex justify-content-between py-4">
          <app-mai-material-bottom-table
                  (changePage)="changePageEvent($event)"
                  [baseDataTableComponent]="baseDatasourceDistributorExclusive"
                  [isFinishLoadingSubject]="baseDatasourceDistributorExclusive.isFinishLoadingSubject"
                  class="w-100"
          ></app-mai-material-bottom-table>
        </div>
      </ng-template>
    </ng-container>
    <!--end::Card body-->
  </app-card>
  <!-- end::Card -->
</ng-template>

<app-modal-detail-with-image #modalDetail
                             [isLoading]="isLoading"
                             [detailModal]="detailDistributorExclusiveData">
</app-modal-detail-with-image>
